import { css, html, LitElement } from "lit"

const recupererPages = async () => {
  const res = await fetch("/content/blog/index.json")
  if (!res.ok) {
    throw new Error(`Impossible de charger la liste des articles (${res.status})`)
  }
  return res.json()
}

export default class PageSommaireBlog extends LitElement {
  static properties = { pages: { type: Array } }

  static styles = css`
    p {
      padding: 16px;
    }

    section {
      padding: 16px;
    }

    section {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    h2 {
      font-size: 1.3em;
    }

    a {
      color: var(--couleur-texte);
      padding: 20px;
    }
  `

  constructor() {
    super()
    this.pages = []
  }

  async firstUpdated() {
    try {
      this.pages = await recupererPages()
    } catch (_erreur) {
      this.pages = []
    }
  }

  render() {
    return html`
    <main>
  <h1>Liste des articles</h1>
  
  <section>
    ${this.pages.map(
      ({ nomFichier, titre }) => html`
        <article>
          <h2>
            <a href="/blog/${nomFichier}">${titre}</a>
          </h2>
          </article>
      `,
    )}
  </section>
</main>
        `
  }
}
customElements.define("p-page-sommaire-blog", PageSommaireBlog)
